import store from '@/store/index'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const user = store.state.userInfo

    if (!value) {
      return true
    }

    if (user.is_super_admin || user.auth_codes.includes(value)) {
      return
    }

    el.parentNode && el.parentNode.removeChild(el)
  }
}
